import(/* webpackMode: "eager" */ "C:\\Users\\User\\Documents\\redeemed bane final website\\redeemedbane\\src\\app\\page.tsx");
